<template src="./Personal.html" />

<script>
// import { showAlert } from "@/utils/helpers";

export default {

  created() {
    this.$store.dispatch("lookups/getLookups");

  },
  computed: {
    socialStatus() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.SocialStatus
      );
    },
    bloodTypes() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.BloodTypes
      );
    },
    diseasesTypes() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.DiseasesTypes
      );
    },
    skinIssuesTypes() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.SkinIssuesTypes
      );
    },
    gender() {
      return [
        { value: 2, label: "انثي" },
        { value: 1, label: "ذكر" },
      ]
    },

  },
  data() {
    return {
      vm: {

        fullName: null,
        socialStatusId: null,
        bloodTypeId: null,
        address: null,
        birthDate: null,
        phoneNo: null,
        identityNo: null,
        gender: null,
        relativePhoneNo: null,
        relativeName: null,

      },
    };
  },
  methods: {
    confirm() {
      this.$store
        .dispatch("bookPatients/addPatient", this.vm)
        .then((res) => {
          this.$emit("next", res.patient.id);
        })
        .catch(() => { });
    },
    cancel() {
      this.$refs.form1.reset();
      this.vm = {
        fullName: null,
        socialStatusId: null,
        bloodTypeId: null,
        address: null,
        birthDate: null,
        phoneNo: null,
        identityNo: null,
        gender: null,
        relativePhoneNo: null,
        relativeName: null,
      };
    },
    allowedDates(val) {
      const today = new Date();
      const date = new Date(val);
      return date < today;
    },

  },
};
</script>